import { Refresh } from "@mui/icons-material";
import { Box, Typography, Button } from "@mui/material";
import { ReactElement, useEffect, useState } from "react";

import { FlexBox } from "../FlexBox";
import { AnalyticsDashboardControls } from "./AnalyticsDashboardControls";
import { Timeframe } from "./timeframes";

const MIN_IFRAME_HEIGHT = 1800;

export function AnalyticsEmbed({
  id,
  iframeUrl,
  height,
  expiresAt,
  timeframe,
  onChangeTimeframe,
  refresh,
}: {
  id: string;
  iframeUrl: string;
  height?: number;
  expiresAt: number;
  timeframe: Timeframe;
  onChangeTimeframe: (newTimeframe: Timeframe) => any;
  refresh: () => Promise<any>;
}): ReactElement {
  const minHeight = height || MIN_IFRAME_HEIGHT;

  const [embedSessionValid, setEmbedSessionValid] = useState<boolean>(true);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const checkTime = () => {
      if (Date.now() > expiresAt) {
        setEmbedSessionValid(false);
      } else {
        setEmbedSessionValid(true);
        // Schedule the next check after 10 seconds
        timeoutId = setTimeout(checkTime, 10000);
      }
    };

    checkTime();

    return () => clearTimeout(timeoutId);
  });

  return (
    <>
      <AnalyticsDashboardControls
        timeframe={timeframe}
        onSubmit={async newTimeframe => {
          onChangeTimeframe(newTimeframe);
          await refresh();
        }}
      />
      <Box>
        {embedSessionValid ? (
          <iframe
            id={`${id}-iframe`}
            title="Embedded analytics"
            src={iframeUrl}
            style={{
              minWidth: "100%",
              maxWidth: "100%",
              minHeight,
              height: "100%",
              border: "none",
            }}
            seamless
          ></iframe>
        ) : (
          <FlexBox
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ py: 5, px: 3 }}
          >
            <Typography component="p" sx={{ mb: 2 }}>
              Your analytics session has expired.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => refresh()}
            >
              Refresh
              <Refresh />
            </Button>
          </FlexBox>
        )}
      </Box>
    </>
  );
}
